jQuery( document ).ready(
	function ( $ ) {
		function URLTRACKING() {

			this.postId = 0
			this.postType = ''
			this.utmString = ''
			this.utmCode = ''
			this.utmSource = ''
			this.utmMedium = ''

			this.init()
		}

		/**
		 * Create the UTM string from the JTF settings and campaign code, then run the trackingLink function
		 * @return { void }
		 */
		URLTRACKING.prototype.init = async function () {
			const self = this // eslint-disable-line consistent-this
			const bodyClasses = $( 'body' ).attr( 'class' )
			const authCode = localObject.jtfRegKey

			const fetchRequestData = { headers: { 'X-WP-Nonce': localObject.wpApiNonce } } // eslint-disable-line object-curly-spacing
			let fetchResponseData = {}
			let fetchResponse = {}

			if ( null != bodyClasses.match( /(postid-\d)\w+/g ) ) {
				self.postId = bodyClasses.match( /(postid-\d)\w+/g ).toString().replace( 'postid-', '' )
			} else if ( null != bodyClasses.match( /(page-id-\d)\w+/g ) ) {
				self.postId = bodyClasses.match( /(page-id-\d)\w+/g ).toString().replace( 'page-id-', '' )
			}

			self.postType = bodyClasses.match( /(jtf_post_type-\w+)/g ).toString().replace( 'jtf_post_type-', '' )
			if ( 'post' == self.postType || 'page' == self.postType ) {
				self.postType = self.postType + 's'
			}

			try {
				fetchResponse = await fetch( '/wp-json/wp/v2/' + self.postType + '/' + self.postId )
				if ( 200 === fetchResponse.status ) {
					fetchResponseData = await fetchResponse.json()
					self.utmCode = fetchResponseData.meta.campaigncode
				}
			} catch ( error ) {
				console.log( 'Fetch error', error )
			}
			fetchResponse = await fetch(
				'/wp-json/jtf/v1/optionspub/get?option=utm_source&auth=' + authCode,
				fetchRequestData, // eslint-disable-line comma-dangle
			)
			fetchResponseData = await fetchResponse.json()
			if ( 'string' === typeof fetchResponseData ) {
				self.utmSource = fetchResponseData
			}
			fetchResponse = await fetch(
				'/wp-json/jtf/v1/optionspub/get?option=utm_medium&auth=' + authCode,
				fetchRequestData, // eslint-disable-line comma-dangle
			)
			fetchResponseData = await fetchResponse.json()
			if ( 'string' === typeof fetchResponseData ) {
				self.utmMedium = fetchResponseData
			}
			fetchResponse = await fetch(
				'/wp-json/jtf/v1/optionspub/get?option=utm_exclusion&auth=' + authCode,
				fetchRequestData, // eslint-disable-line comma-dangle
			)
			fetchResponseData = await fetchResponse.json()
			if ( 'string' === typeof fetchResponseData ) {
				self.utmExclusion = fetchResponseData.split( ',' )

				let prefix = 'postid-'
				let regex = new RegExp( `(${prefix}\\d)\\w+`, "g" )
				const matchingBodyClass = bodyClasses.match( regex )[ 0 ]

				if ( false === self.utmExclusion.includes( matchingBodyClass.slice( prefix.length ) ) ) {
					self.utmString = 'utm_source=' + self.utmSource + '&utm_medium=' + self.utmMedium + '&utm_campaign=' + self.utmCode
					$( 'a' ).each( function () {
						if ( $( this ).hasClass( 'exclude-cc' ) ) {
						} else if ( $( this ).parent().hasClass( 'twitter__widget--image' ) ) {
						} else {
							self.trackingLink( $( this ), self.utmString )
						}
					} )
				}

			}
		}
		/**
		 * Implement the UTM string on the hyperlink
		 *
		 * @param current - The current instance of the <a> tag
		 * @return { void } - Update the <a> tag href with the correct UTM string
		 */
		URLTRACKING.prototype.trackingLink = function ( current, utmString ) {
			const href = current.attr( 'href' )
			if ( href ) {
				if ( !href.includes( 'mailto:' ) ) {
					const indexPosition = href.indexOf( '#' )
					const slicePosition = href.slice( indexPosition )
					const stringWithoutHash = href.replace( slicePosition, '' )

					// This is to check for single-page app links used on CPB, e.g. https://accounts.taylorfrancis.com/identity/#/login?
					if ( href.includes( '/#/' ) ) {
						if ( href.includes( '?' ) ) {
							current.attr( 'href', href + '&' + utmString )
						} else {
							current.attr( 'href', href + '?' + utmString )
						}
					} else {
						if ( href.includes( '?' ) && !href.includes( '#' ) ) {
							current.attr( 'href', href + '&' + utmString )
						} else if ( href.includes( '#' ) && !href.includes( '?' ) ) {
							current.attr( 'href', stringWithoutHash + '?' + utmString + slicePosition )
						} else if ( href.includes( '#' ) && href.includes( '?' ) ) {
							current.attr( 'href', stringWithoutHash + '&' + utmString + slicePosition )
						} else {
							current.attr( 'href', href + '?' + utmString )
						}
					}
				}
			}
		}
		// Instantiate this JS if class is present
		if ( $( 'body' ).hasClass( 'jtf_utm_tracking' ) ) {
			new URLTRACKING() // eslint-disable-line no-new
		}
	}, // eslint-disable-line comma-dangle
)